import { observer } from 'mobx-react';
import React, { ChangeEvent, useCallback } from 'react';
import { RESTRICTION_ACCESS } from 'src/constants/integrations';
import { IPriceValidation } from 'src/types/main';
import { isDisabledByPos, stringTransform } from 'src/utils/helpers';
import { floatNumbersValidation } from 'src/utils/validation';
import { ICustomTooltipProps } from 'src/view/components/Controls/CustomTooltip/CustomTooltip';
import InputAlt from 'src/view/components/Controls/InputAlt/InputAlt';
import IntegrationManager from 'src/view/components/IntegrationManager/IntegrationManager';

interface IProps {
  price?: string | number;
  validation?: IPriceValidation;
  posRestriction?: RESTRICTION_ACCESS;
  disabled?: boolean;
  changePrice: (price: string) => void;
  setValidation?: () => void;
  className?: string;
  wrapperClassName?: string;
  tooltipOptions?: Partial<ICustomTooltipProps>;
}

const MenuManagTabItemPriceInput: React.FC<IProps> = observer((props: IProps): JSX.Element => {
  const changePrice = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const price: string = stringTransform(event.target.value.toString());
      if (!floatNumbersValidation(price, 1)) return;

      props.changePrice(price);
      // update validation
      if (props.validation && !props.validation?.state && props.setValidation) props.setValidation();
    },
    [props.validation, props.setValidation]
  );

  return (
    <IntegrationManager
      setting={props.posRestriction}
      wrapperClassName={props.wrapperClassName}
      withTooltip
      tooltipOptions={{ wrapperClassName: 'w-fit-content' }}>
      <InputAlt
        type="text"
        value={props.price}
        onInput={changePrice}
        validation={props.validation ? { ...props.validation, styleType: 'bottom' } : undefined}
        disabled={props.disabled && !isDisabledByPos(props.posRestriction)}
        className={`py-0 ${props.className || ''}`}
      />
    </IntegrationManager>
  );
});

export default MenuManagTabItemPriceInput;
